import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { logout } from "../redux/actions/LoggedInAction";
import Topbar from "../layouts/TopBar";
import Footer from "../layouts/Footer";
import Select from 'react-select';
import toast from 'react-hot-toast';
import moment from "moment";
import {ACCESS_DENIED} from '../Messages'
import ClockinResources from "../resources/ClockinResources";
import LocationResources from "../resources/LocationResources";

// Hardcoded until coordinates are stored in the Locations table
const LOCATION_COORDS = {
    'liberty point': { lat: 51.6110, lng: 0.0215 },
    'canary wharf':  { lat: 51.5070, lng: -0.0194 },
    'croydon':       { lat: 51.3524, lng: -0.1068 },
    'north london':  { lat: 51.5295, lng: -0.1713 },
    'birmingham':    { lat: 52.4967, lng: -1.8742 },
}

function haversineDistanceMiles(lat1, lon1, lat2, lon2) {
    const R = 3958.8
    const dLat = (lat2 - lat1) * Math.PI / 180
    const dLon = (lon2 - lon1) * Math.PI / 180
    const a = Math.sin(dLat / 2) ** 2 +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) ** 2
    return R * 2 * Math.asin(Math.sqrt(a))
}


function MediaClockIn({isLoggedIn, loggedInUser, logout}){
    const [time, setTime] = useState(new Date().toLocaleTimeString());
    const [locations, setLocations] = useState([])
    const [selectedLocation, setSelectedLocation] = useState('')
    const [selectedService, setSelectedService] = useState('')
    const [checkingLocation, setCheckingLocation] = useState(false)

    let locationResources = new LocationResources()
    let clockinResources = new ClockinResources()

    useEffect(() => {
        loadLocations().then(response => {
            setLocations(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });

        const timer = setInterval(() => {
            setTime(new Date().toLocaleTimeString());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const loadLocations = () => {
        return locationResources.get()
    }

    const handleLocationSelection = (location) => {
        setSelectedLocation(location);
    };

    const handleServiceSelection = (service) => {
        setSelectedService(service);
    };

    let mediaLocations = []
    locations.map((loc) => (
        mediaLocations.push({value: loc['id'], label: loc['name'] })
    ))

    let services = []
    services.push({value: 'First', label: 'First' })
    services.push({value: 'Second', label: 'Second' })
    services.push({value: 'Both', label: 'Both' })

    const submitClockin = () => {
        let clockindata = {}
        clockindata['clockin_time'] = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        clockindata['service'] = selectedService['value']
        clockindata['location_id'] = selectedLocation['value']
        clockindata['user_id'] = loggedInUser['id']

        clockinResources.post(clockindata).then(res => {
            if (res.error.length < 1) {
                toast.success("Successfully clocked in!")
                setTimeout(() => {
                    window.location.href = window.location.origin + '/'
                }, 1500)
            } else {
                toast.error("An issue occurred, please retry.")
            }
        }).catch((err) => {
            toast.error("Network Error: " + err)
        })
    }

    const handleClockinButtonClick = () => {
        if (!selectedService || selectedService.length === 0) {
            toast.error("Please select which service(s) you are serving at.")
            return
        }
        if (!selectedLocation || selectedLocation.length === 0) {
            toast.error("Please select the location you are serving today.")
            return
        }

        const locationName = (selectedLocation.label || '').toLowerCase()
        const coordsEntry = Object.entries(LOCATION_COORDS).find(([key]) => locationName.includes(key))

        if (!coordsEntry) {
            submitClockin()
            return
        }

        if (!navigator.geolocation) {
            toast.error("Geolocation is not supported by your browser.")
            return
        }

        const coords = coordsEntry[1]
        setCheckingLocation(true)
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setCheckingLocation(false)
                const dist = haversineDistanceMiles(
                    position.coords.latitude, position.coords.longitude,
                    coords.lat, coords.lng
                )
                if (dist > 1.0) {
                    toast.error(`You must be within 1 mile to clock in here. You are currently ${dist.toFixed(1)} miles away.`)
                    return
                }
                submitClockin()
            },
            () => {
                setCheckingLocation(false)
                toast.error("Location access was denied. To enable it, tap the lock icon in your browser's address bar, allow location access, then try again.", { duration: 6000 })
            },
            { timeout: 10000, maximumAge: 60000 }
        )
    }

    return(
        <Fragment>
            <Topbar/>

            <div className="hero-area">
                <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                            {isLoggedIn ?
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>Member Clock In</strong></h1>
                                :
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>{ACCESS_DENIED}</strong></h1>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                {isLoggedIn ? (
                    <div className="container">
                        <div className="spacer-40"></div>

                        {/* Current time display */}
                        <div style={{
                            backgroundColor: '#003165',
                            borderRadius: '10px',
                            padding: '20px 30px',
                            marginBottom: '30px',
                            textAlign: 'center'
                        }}>
                            <div style={{color: '#fff', fontSize: 'clamp(13px, 3vw, 15px)', marginBottom: '4px'}}>Current Time</div>
                            <div style={{color: '#ffa800', fontSize: 'clamp(26px, 6vw, 42px)', fontWeight: 'bold', letterSpacing: '2px'}}>{time}</div>
                            <div style={{color: '#aac0d8', fontSize: 'clamp(12px, 2.5vw, 14px)', marginTop: '4px'}}>{moment().format('dddd, DD MMMM YYYY')}</div>
                        </div>

                        {/* Clock in form */}
                        <div style={{
                            backgroundColor: '#fff',
                            borderRadius: '10px',
                            border: '1px solid #e0e0e0',
                            padding: '30px',
                            marginBottom: '30px',
                            maxWidth: '600px'
                        }}>
                            <h3 style={{color: '#003165', marginBottom: '24px'}}><strong>Clock In</strong></h3>

                            <div style={{marginBottom: '20px'}}>
                                <label style={{color: '#ffa800', fontWeight: 'bold', display: 'block', marginBottom: '6px'}}>Location</label>
                                <Select
                                    name='location'
                                    id="location"
                                    classNamePrefix='select-css-tag'
                                    onChange={handleLocationSelection}
                                    options={mediaLocations}
                                    placeholder="Select Location"
                                />
                            </div>

                            <div style={{marginBottom: '28px'}}>
                                <label style={{color: '#ffa800', fontWeight: 'bold', display: 'block', marginBottom: '6px'}}>Service</label>
                                <Select
                                    name='service'
                                    id="service"
                                    classNamePrefix='select-css-tag'
                                    onChange={handleServiceSelection}
                                    options={services}
                                    placeholder="Select Service"
                                />
                            </div>

                            <button
                                onClick={handleClockinButtonClick}
                                disabled={checkingLocation}
                                style={{
                                    backgroundColor: checkingLocation ? '#7a9bbf' : '#003165',
                                    color: '#fff',
                                    padding: '12px 36px',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: checkingLocation ? 'not-allowed' : 'pointer',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    transition: 'background-color 0.2s'
                                }}
                            >
                                {checkingLocation ? 'Checking location...' : 'Clock In'}
                            </button>
                        </div>

                        <div className="spacer-40"></div>
                    </div>
                ) : <></>}
            </div>

            <Footer/>
        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };
};

const mapDispatchToProps = {
    logout
};

export default connect(mapStateToProps, mapDispatchToProps)(MediaClockIn);
